import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface TrapChallengeContainerPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTrapChallengeContainer = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 8px;
            padding: ${theme.star.padding.medium} 0;
            border-radius: ${theme.star.radius.medium};
            background: ${theme.star.raceSummary.bgColor};
        `;
    }
    return css`
        margin-bottom: 20px;
    `;
};

export const TrapChallengeContainer = withConfig(theme => styled('div', { label: 'TrapChallengeContainer' })<TrapChallengeContainerPropsType>`
    ${({ variant }): SerializedStyles => setTrapChallengeContainer(variant, theme)}
    overflow-x: auto;
`);

interface TrapHeaderListPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTrapHeaderList = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
        `;
    }
    return css`
        border-color: ${theme.star.raceSummary.borderColor};
        border-style: solid;
        border-width: 1px 0;
    `;
};

export const TrapHeaderList = withConfig(theme => styled('ul', { label: 'TrapHeaderList' })<TrapHeaderListPropsType>`
    ${({ variant }): SerializedStyles => setTrapHeaderList(variant, theme)}
    display: grid;
    grid-template-columns: repeat(6, 70px);
    min-width: max-content;
    line-height: 1;
    text-align: center;
    @media ${theme.star.mediaQuery.tablet} {
        grid-template-columns: repeat(6, 67px);
        padding-left: 264px;
    }
`);

interface TrapNumberSilkPropsType {
    variant: DefaultComponentVariantType | null;
}

const setTrapNumberSilk = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        border-width: 0 1px 0 0;
        border-style: solid;
        border-color: ${theme.star.raceSummary.borderColor};
        &:first-of-type {
            border-left-width: 0;
        }
        @media ${theme.star.mediaQuery.tablet} {
            &:first-of-type {
                border-left-width: 1px;
            }
        }
    `;
};

export const TrapNumberSilk = withConfig(theme => styled('li', { label: 'TrapNumberSilk' })<TrapNumberSilkPropsType>`
    ${({ variant }): SerializedStyles => setTrapNumberSilk(variant, theme)}
    padding: 6px 12px 5px;
    img {
        display: block;
        margin: 0 auto;
        width: 29px;
    }
`);

interface CompetitionRowPropsType {
    variant: DefaultComponentVariantType | null;
}

export const CompetitionRow = withConfig(theme => styled('div', { label: 'CompetitionRow' })<CompetitionRowPropsType>`
    border-bottom: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.raceSummary.borderColor}`};
    display: flex;
    flex-direction: column;
    flex: 1 1 0%;
    font-size: ${theme.star.fontSize.xRegular};
    position: relative;
    white-space: nowrap;
    width: 100%;
    min-width: fit-content;
    @media ${theme.star.mediaQuery.tablet} {
        flex-direction: row;
    }
`);

interface CompetitionRowNamePropsType {
    variant: DefaultComponentVariantType | null;
}

export const CompetitionRowName = withConfig(theme => styled('div', { label: 'CompetitionRowName' })<CompetitionRowNamePropsType>`
    border-bottom: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'none': `1px solid ${theme.star.raceSummary.borderColor}`};
    color: ${theme.star.raceSummary.txtColor};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    height: 24px;
    line-height: 1;
    overflow: hidden;
    padding: 5px 8px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    @media ${theme.star.mediaQuery.tablet} {
        background-color: inherit;
        border-bottom: none;
        flex: 0 0 264px;
        font-weight: ${theme.star.fontWeight.regular};
        height: 40px;
        line-height: 1.3334;
        padding: 12px 8px;
    }
    @media ${theme.star.mediaQuery.largeDesktop} {
        font-size: ${theme.star.fontSize.small};
    }
`);

interface CompetitionRowTrapListPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCompetitionRowTrapList = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
        `;
    }
    return css`
        background-color: ${theme.star.eventRow.bgColor};
    `;
};

export const CompetitionRowTrapList = withConfig(theme => styled('ul', { label: 'CompetitionRowTrapList' })<CompetitionRowTrapListPropsType>`
    ${({ variant }): SerializedStyles => setCompetitionRowTrapList(variant, theme)}
    display: grid;
    grid-template-columns: repeat(6, 70px);
    @media ${theme.star.mediaQuery.tablet} {
        grid-template-columns: repeat(6, 67px);
        overflow-x: initial;
    }
`);

interface CompetitionRowsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setCompetitionRowsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.small};
        `;
    }
    return css``;
};

export const CompetitionRowsWrapper = withConfig(theme => styled('div', { label: 'CompetitionRowsWrapper' })<CompetitionRowsWrapperPropsType>`
    ${({ variant }): SerializedStyles => setCompetitionRowsWrapper(variant, theme)}
`);
